module.exports = __webpack_public_path__ + "img/about-us-bg_768.545b4b56.png";